import { ReactNode } from "react";

import { Column, MAX_POPOVER_HEIGHT_SM, VerticalScroll } from "@bridgesplit/ui";
import { Divider } from "@mui/material";

export function PopoverContentSection({
    children,
    dividerBottom = true,
    dividerTop = false
}: {
    children: ReactNode;
    dividerBottom?: boolean;
    dividerTop?: boolean;
}) {
    return (
        <Column>
            {dividerTop && <Divider />}

            <Column sx={{ p: 1.5 }}>{children}</Column>
            {dividerBottom && <Divider />}
        </Column>
    );
}

export function PopoverContent({ children, scroll = true }: { children: ReactNode; scroll?: boolean }) {
    return (
        <>
            {scroll ? (
                <PopoverScrollContent>{children}</PopoverScrollContent>
            ) : (
                <PopoverStaticContent>{children}</PopoverStaticContent>
            )}
        </>
    );
}

function PopoverScrollContent({ children }: { children: ReactNode }) {
    return (
        <VerticalScroll spacing={0} maxHeight={MAX_POPOVER_HEIGHT_SM}>
            {children}
        </VerticalScroll>
    );
}

function PopoverStaticContent({ children }: { children: ReactNode }) {
    return <Column>{children}</Column>;
}
